import { apiSlice } from "../../app/api/apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        login: builder.mutation({
            query: credentials => ({
                url: '/Auth/authenticate',
                method: 'POST',
                body: { ...credentials }
            })
        }),
        changePassword: builder.mutation({
            query: credentials => ({
                url: '/Auth/changePassword',
                method: 'POST',
                body: { "userId": credentials.userId, "currentPassword": credentials.currentPassword, "newPassword": credentials.newPassword  }
            })
        }),
    })
})

export const {
    useLoginMutation,
    useChangePasswordMutation
} = authApiSlice